<template>
    <div id="modelmanager" v-show="show">
        <div class="model_tj" v-show="modeldel">
            <div class="com_wrap">
                <div class="com_top">
                    <h1 class="lf">{{title}}</h1>
                    <div class="rf closebtn" >
                            <img src="/static/img/err.png"  @click="closebtn(2)">
                    </div>
                </div>
                <div class="tc_nr" slot="del">
                    <h1>{{nrtitle}}</h1>
                </div>
                <div class="com_btn">
                    <button class="fal_btn" @click="closebtn(2)">取消</button>
                    <button class="suc_btn" @click="delbtn()">确定</button>
                </div>
            </div>
        </div>
        <div class="model_oa model_tj" v-show="modeloa">
            <div class="com_wrap">
                <div class="com_top">    
                    <h1 class="lf">{{title}}</h1>
                    <div class="rf closebtn" >
                    <img src="/static/img/err.png"  @click="closebtn(3)">
                    </div>
                </div>    
                <div class="oa_inp">
                    <span>请选择部门/人员</span>
                    <input type="text" class="oa_sear" placeholder="快速查找人员" @change="userSear()">
                </div>
                <div class="clear"></div>
                <div class="oa_list">
                    <div v-for="(arr,i) in listoa" :key='i' style="margin-bottom:10px" class="oaname">
                        <input type="checkbox" class="checkjs lf" v-model="rycheck" style="margin-top:5px;margin-right:10px" :data-id='arr.user_id'>
                        <span>{{arr.nickname}}</span>
                    </div>
                     <div class="tc_m lf">
                    <span>添加管理权限</span>
                        </div>
                        <div class="tc_check lf">
                            <ul>
                                <li v-for="(item,index) in listbm" :key="index" :data-id="item.part_id">
                                    <input class="checkbox" type="radio" v-model="item.part_info=='yes' ? checkitem=1 : checkitem=2" @click="check(3,item.part_id)" name="edit" :value="1">
                                    <em>{{item.part_name}}</em>
                                </li>
                            </ul>
                        </div>
                </div>
                <div class="clear"></div>
                <div class="com_btn">
                    <button class="suc_btn" @click="upid(1)">确定</button>
                </div>
            </div>
        </div>
        <div class="model_add model_tj" v-show="modeluser">
            <div class="com_wrap">
                <div class="com_top">
                    <h1 class="lf">{{title}}</h1>
                    <div class="rf closebtn" >
                            <img src="/static/img/err.png"  @click="closebtn(4)">
                    </div>
                </div>
                <div class="tc_nr" slot="del" style="text-align:left">
                    <span style="line-height: 32px;
    margin-right: 17px;
    width: 84px;
    display: block;
    float: left;
    text-align: right;x">角色名</span><input type="text" class="up_nr" placeholder="请输入角色名" v-model=" jsusername">
                </div>
                <div class="tc_m lf">
                    <span>添加管理权限</span>
                </div>
                <div class="tc_check lf">
                    <ul>
                        <li v-for="(item,index) in listjs" :key="index" :data-id="item.id">
                            <span class="lf">{{item.auth_name}}</span>
                            <div style="width:100%;overflow:hidden">
                                <div v-for="(ix,i) in item.child" class="lf" style="margin-right:20px;margin-top:10px;margin-bottom:10px">
                                    <em style="margin-left:0;margin-right:10px">{{ix.auth_name}}</em>
                                    <input class="checkbox"  type="checkbox"  @click="check(2,ix.auth_id)">
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="com_btn">
                    <button class="fal_btn" @click="closebtn(4)">取消</button>
                    <button class="suc_btn" @click="upid(2)">确定</button>
                </div>
            </div>
        </div>
        <div class="model_edit model_tj" v-show="edit" v-if="part==1">
            <div class="com_wrap">
                <div class="com_top">
                    <h1 class="lf">{{title}}</h1>
                    <div class="rf closebtn" >
                            <img src="/static/img/err.png"  @click="closebtn(5)">
                    </div>
                </div>
                <div class="tc_jqx">
                    <span>角色名</span><input type="text" class="up_nr" placeholder="请输入角色名" v-model="jsname">
                    <div class="tc_qx">
                        <div class="tc_m lf">
                            <span>添加管理权限</span>
                        </div>
                        <div class="tc_check lf">
                            <ul>
                               
                                <li v-for="(item,index) in listjs" :key="index" :data-id="item.id">
                                    <span class="lf" style="margin-left:0;text-align:left">{{item.auth_name}}</span>
                                    <div style="width:100%;overflow:hidden">
                                         <div class="">
                                            <el-checkbox-group 
                                                    v-model="jscheck"
                                                    >
                                                <el-checkbox  @change="check(2,ix.auth_id)" v-for="(ix,i) in item.child" :label="ix.auth_id" :key="i"  >{{ix.auth_name}}</el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="com_btn">
                    <button class="fal_btn" @click="closebtn(5)">取消</button>
                    <button class="suc_btn" @click="upid(3)">确定</button>
                </div>
            </div>
        </div>
        <div class="model_edit model_tj" v-show="edit" v-if="part==2">
            <div class="com_wrap">
                <div class="com_top">
                    <h1 class="lf">{{title}}</h1>
                    <div class="rf closebtn" >
                            <img src="/static/img/err.png"  @click="closebtn(5)">
                    </div>
                </div>
                <div class="tc_jqx">
                    <span>角色名</span><b>{{jsname}}</b>
                    <div class="tc_qx">
                        <div class="tc_m lf">
                            <span>添加管理权限</span>
                        </div>
                        <div class="tc_check lf">
                            <ul>
                                <li v-for="(item,index) in listbm" :key="index" :data-id="item.part_id">
                                    
                                    <input class="checkbox" type="radio" v-model="listadmin" @click="check(3,item.part_id)" name="edit" :value="item.part_id">
                                    <em>{{item.part_name}}</em>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="com_btn">
                    <button class="fal_btn" @click="closebtn(5)">取消</button>
                    <button class="suc_btn" @click="upid(4)">确定</button>
                </div>
            </div>
        </div>
     

    </div>
</template>

<script>
 export default{
    inject:["reload"],
    props: {
        modelt:{
            type:Boolean,
            default: false
        },
        modelpeo:{
            type:Boolean,
            default: false},
        modelde:{
            type:Boolean,
            default: false
        },
        modeloff:{
            type:Boolean,
            default: false
        },
        medit:{
            type:Boolean,
            default:false
        },
        modeuser:{
            type:Boolean,
            default:false
        },
        modelhf:{
            type:Boolean,
            default:false
        },
        show: {
            type: Boolean,
            default: false
        },
        part:{
            default:''
        },
        title: {
            type: String,
            default: ''
        },
        nrtitle:{
            type:String,
            default:''
        },
  
        delp:{
            type:String,
            default:''
        },
        delid:{
            type:String,
            default:''
        },

        id:{
            default:''
        },
        dataid:{
            default:''
        },
        listedit:{
            type:Array,
            default:[]
        },
        listadmin:{
            type:String,
            default:''
        },
        listcheckid:{
            type:Array,
            default:''},
        username:{
            type:String,
            default:''
        },
        jsname:{
            default:''
        },
        listData:{
        },
        tcid:{default:''}
      },
    computed:{
         modelshow:function(){
             return this.modelt
         },
         modeldel:function(){
            return this.modelde
         },
         modeloa:function(){
             return this.modelpeo
         },
          modelfoa:function(){
             return this.modeloff
         },
         modeluser:function(){
             return this.modeuser
         },
   
         edit:function(){
             
             this.jscheck=this.listedit
             this.checkitem= this.listadmin
             return this.medit
         },
         checkid:function(){
             return this.listcheckid
         }
    },
    data(){
        return{
            listoa:[],
            listlen:[],
            listjs:[],
            listuser:[],
            listche:0,
            listnm:0,
            listbm:[],
            rycheck:true,
            listarr:[],
            jsusername:'',
            jscheck:[],
            listck:[],
            active:'',
            typeid:'',
            checkitem:false,
            jsitem:1,
        }
    },
     mounted(){
          var oH = document.body.clientHeight;
          var str =this.listarr
          document.getElementById('model').style.height = oH + 'px';
           
            var datajs={
                service:'Admin.Auth_list',
                userid:localStorage.getItem('userid')
            } 
             this.$axios.post(this.HOME,this.$qs.stringify(datajs))
                .then(res => {
                
                    this.listjs = res.data.data
                })
                .catch(function (error) { // 请求失败处理
            });    
            
             var data={
                service:'Admin.Part_All',
                userid:localStorage.getItem('userid')
            } 
             this.$axios.post(this.HOME,this.$qs.stringify(data))
                .then(res => {
                  
                        this.listbm = res.data.data.info
                    
                })
                .catch(function (error) { // 请求失败处理
            });
     },
    methods:{
        closebtn(id){
            if(id==1){
            this.$emit('update:modelt',false)
            this.$emit('update:show',false)
            }
            else if(id==2){
            this.$emit('update:modelde',false)
            this.$emit('update:show',false)
            }
            else if(id==3){
            this.$emit('update:modelpeo',false)
            this.$emit('update:show',false)
            }
            else if(id==4){
            this.$emit('update:modeuser',false)
            this.$emit('update:show',false)
            } 
            else if(id==5){
            this.$emit('update:medit',false)
            this.$emit('update:show',false)
                this.reload()
            }
         
        },
        upid(key){
            if(key==1){
            let name =$('.model_oa').find('.oaname').find('li').find('span').text()
            var ck = $('.checkjs').prop('checked')
            console.log($('.checkjs').attr('data-id'))
            if(ck===false){
                 this.alertView.failView('请选择要添加的管理员')
                 return false
            } 
            if($('.checkjs').attr('data-id')==undefined){
                this.alertView.failView('请选择要添加的管理员')
                 return false
            }
            this.$emit('update:show',false)
            this.$emit('update:modelpeo',false)
            var dt = {
                service:'Admin.Admin_Add',
                userid:localStorage.getItem('userid'),
                part_id:this.listche,
                admin_id:$('.checkjs').attr('data-id')
                }
            this.$axios.post('http://exam.junchenlun.com/testexam/',this.$qs.stringify(dt))
            .then(res=>{
               if(res.data.data.code!==0){
                    this.alertView.failView(res.data.data.msg)
                    return false
                }
                this.alertView.successView('添加成功')
                this.reload()
            })
             .catch(function (error) { // 请求失败处理
                console.log(error)
            });
            }
            else if(key==2){
            this.$emit('update:show',false)
            this.$emit('update:modeuser',false)
            let txt = this.listcheckid.join(',')
            this.$emit('add',this.jsusername,txt)
            }
            else if(key==3){
                this.$emit('update:show',false)
                this.$emit('update:edit',false)
                let txt =this.jscheck.join(',')
                this.$emit('editname',this.jsname,txt)
                this.$emit('update:jsname',this.jsname)
            }
            else if(key==4){
                console.log(this.listadmin)
                this.$emit('update:show',false)
                this.$emit('update:edit',false)
                let txt =this.jscheck.join(',')
                this.$emit('editname',this.jsname,this.listadmin)
                this.$emit('update:jsname',this.jsname)
            }
        },
        delbtn(){
            this.$emit('delt',this.id,this.dataid)
            this.$emit('update:modelde',false)
            this.$emit('update:show',false)
        },

        txbtn(){
            this.tcid=2
            this.$emit('showb',3)
            this.$emit('update:show',true)
            this.$emit('update:modelt',false)
            this.$emit('tcpid',this.tcid)
        },
        oaup(index,name){
            event.stopPropagation()
            this.active = name
            this.listlen=[]
            var str =this.listarr
            var updata={
                service:'Admin.Dept_User'
            }
            this.$axios.post(this.HOME,this.$qs.stringify(updata))
            .then(res=>{
                if(res.data.data.info[index].dept==''){
                    this.listlen.splice(0,1,res.data.data.info[index].user)
                $.each(res.data.data.info[index].user,function(i,index){
                    if(index.user_info=='yes')
                        {
                            str.push({'id':index.user_id,'class':'user','pid':'0'})
                        }
                    })
                sessionStorage.setItem('sid',JSON.stringify(str))
                }
                else{
                    this.listlen.splice(0,1,res.data.data.info[index].dept)

                        $.each(res.data.data.info[index].dept,function(i,index){
                            console.log(index)
                            if(index.sec_info=='yes')
                                {
                                    str.push({'id':index.id,'class':'down','pid':index.pid})
                                }
                            })
                        sessionStorage.setItem('sid',JSON.stringify(str))
                }
            })
             .catch(function (error) { // 请求失败处理
                console.log(error)
            });
        },
        check(key,id,type,cid){
            if(key==1){
                if(event.target.checked==true){
                    this.listarr.push({'id':id,'class':type==1? "top" : type==2 ? "down" : "user",'pid':cid})
                    sessionStorage.setItem('sid',JSON.stringify(this.listarr))
                    this.$axios.get('http://pf.junchenlun.com/api/v1/section/'+id+'?checked=true') .then(res=>{
                    })
                    .catch(function (error) { // 请求失败处理
                         console.log(error)
                    }); 
                }
                else{
                    var new_data = this.listarr.filter(function(element, index) {
                        return element['id']!=id
                    });
                    this.listarr =new_data
                    sessionStorage.setItem('sid',JSON.stringify(this.listarr))
                }
            }
            else if(key==2){
                if(event.target.checked==true){
                    this.listcheckid.push(id)
                }
                else{
                    var new_data = this.listcheckid.filter(function(element, index) {
                        return element!=id
                    });
                    this.listcheckid =new_data
                }
            }
            else if(key==3){
                this.listche= id
                this.$emit('update:partid',id)
            }

        },
        checkall(key){
            if(key==1){
                if(event.target.checked==true){
                    this.listoa.forEach(item => {
                        item.forEach(item => {
                            item.temp='yes'
                            this.listarr.push({'id':item.id,'class':item.type==1? "top" : item.type==2 ? "down" : "user",'pid':item.pid? item.pid: '0'})
                            sessionStorage.setItem('sid',JSON.stringify(this.listarr))
                        });
                    });
                }
                else{
                    this.listoa.forEach(item => {
                        item.forEach(item => {
                            item.temp='no'
                            var new_data = this.listarr.filter(function(element, index) {
                            return element['id']!=item.id
                            });
                            this.listarr =new_data
                            sessionStorage.setItem('sid',JSON.stringify(this.listarr))
                        });
                    });
                }
            }
            else{
                if(event.target.checked==true){
                    this.listlen.forEach(item => {
                        item.forEach(item => {
                            if(item.sec_info){
                                item.sec_info='yes'
                                var id=item.id
                                console.log(id)
                            }
                            else{
                                item.user_info='yes'
                                var id=item.user_id
                            }
                            this.listarr.push({'id':id,'class':item.type==1? "top" : item.type==2 ? "down" : "user",'pid':item.pid? item.pid: '0'})
                            sessionStorage.setItem('sid',JSON.stringify(this.listarr))
                        });
                    });
                }
                else{
                    this.listlen.forEach(item => {
                        item.forEach(item => {
                            if(item.sec_info){
                                item.sec_info='no'
                                var id=item.id
                            }
                            else{
                                item.user_info='no'
                                var id=item.user_id
                            }
                           var new_data = this.listarr.filter(function(element, index) {
                            return element['id']!=id
                            });
                            this.listarr =new_data
                            sessionStorage.setItem('sid',JSON.stringify(this.listarr))
                        });
                    });
                }
            }
        },
        htmlov(){
            $('html').css('overflow','auto')
        },
        olistup(index,name,tid,cid,len){
            this.active = name
            var str =this.listarr
            this.typeid= tid
            if(tid==''){}
            else{
            this.$axios.get('http://pf.junchenlun.com/api/v1/section/'+tid+'?checked=false')
            .then(res=>{
                console.log('321')
                if(res.data.data[index].id==cid){
                    if(res.data.data[index].list==''){
                        if(res.data.data[index].user==''){
                            this.listlen.splice(len+1,1)
                        }
                        else{
                        this.listlen.splice(len+1,1,res.data.data[index].user)}
                        $.each(res.data.data[index].user,function(i,index){
                            if(index.user_info=='yes')
                                {
                                    str.push({'id':index.user_id,'class':'user','pid':'0'})
                                }
                            })
                         sessionStorage.setItem('sid',JSON.stringify(str))

                    }
                    else{
                       this.listlen.splice(len+1,1,res.data.data[index].list)
                        $.each(res.data.data[index].list,function(i,index){
                            if(index.sec_info=='yes')
                                {
                                    str.push({'id':index.id,'class':'user','pid':index.pid})
                                }
                        })
                        sessionStorage.setItem('sid',JSON.stringify(str))
                    }

                }

                })
            .catch(function (error) { // 请求失败处理
                console.log(error)
            });    
            }
        },
    offup(){
        this.listck=[]
        let str= this.listck
        let conname =$('.cread_cpeo').find('span').text()
            $('.oa_nwrap').last().find('li').each(function(){
                if($(this).find('input').prop('checked')==true){
                   var name =$(this).find('span').text()
                   if(conname.indexOf(name)!=-1){
                   }   
                   else{
                   str.push(name)
                   }
                }
            })
            this.$emit('listck', this.listck)
            
            this.$emit('update:show',false)
            this.$emit('update:modelfoa',false)
        },
    userSear(){
      var that =this
      let seartxt =$('.oa_sear').val();
      console.log(seartxt)
      var str =this.listarr
      this.listlen=[]
      var sr=this.listlen
  
        var dt = {
            service:'Admin.Admin_search',
            nickname:seartxt,
        }
        this.$axios.post('http://exam.junchenlun.com/testexam/',this.$qs.stringify(dt))
        .then(res=>{
                if(res.data.data.code){
                    this.listoa=[]
                }
                else{
                    this.listoa=[]
                    this.listoa.push(res.data.data)
                }
              
        })
            .catch(function (error) { // 请求失败处理
        });    
    },
    ceshi(data,sr,str,that){
        $.each(data,function(i,index){
        if(index.sec_info=='yes')
            {
            if(data[i].list==''){
                    sr.push(index.user)
                    str.push({'id':index.user[i].user_id,'class':'user',pid:'0'})
                }
                else{
                    sr.push(index.list)
                    str.push({'id':index.id,'class':'down'})
                    that.$options.methods.ceshi(index.list,sr,str,that);
                }
                }
            })
         sessionStorage.setItem('sid',JSON.stringify(str))
        }
    }
 }
</script>
<style>
@import "../../assets/css/manager.css";

.tc_check .el-checkbox__input,.tc_check .el-checkbox__inner{width: 18px !important; margin-right: 4px !important;height: 18px !important;}
.el-checkbox__label {width: auto !important; margin-right: 0px !important;line-height: 14px !important;}
.tc_check .el-checkbox__inner::after{left: 5px !important;top: 0 !important;width: 6px !important;height: 11px !important;}
.ViewDialog_Exams .el-checkbox__label{line-height: 36px !important;}
</style>
 


// WEBPACK FOOTER //
// src/components/manager/tc.vue